/**
 * ReferralWelcomeBanner — the REFERRED merchant's 7-day welcome.
 *
 *   "Welcome — your referrer gave you a bonus credit pack. Here's what's
 *    unlocked: 3 image ads, 1 product build… (used first, expire Oct 19)"
 *
 * Shown on every page (mounted in AppLayout) from the moment the welcome
 * grant lands until the merchant dismisses it or 7 days pass — the backend
 * (GET /api/referral/welcome) owns the window. Dismissal is persisted.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Banner } from '@shopify/polaris';
import { fetchReferralWelcome, dismissReferralWelcome, REFERRALS_ROUTE } from '../lib/referral';

export default function ReferralWelcomeBanner({ shop }) {
  const navigate = useNavigate();
  const [welcome, setWelcome] = useState(null);

  useEffect(() => {
    if (!shop) return undefined;
    let alive = true;
    fetchReferralWelcome().then((w) => { if (alive && w?.show) setWelcome(w); }).catch(() => {});
    return () => { alive = false; };
  }, [shop]);

  if (!welcome) return null;
  const expires = welcome.expiresAt
    ? new Date(welcome.expiresAt).toLocaleDateString(undefined, { month: 'long', day: 'numeric' }) : null;

  return (
    <div style={{ padding: '12px 16px 0' }} data-testid="referral-welcome-banner">
      <Banner
        title="Welcome — your referrer gave you a bonus credit pack 🎁"
        tone="success"
        onDismiss={() => { setWelcome(null); dismissReferralWelcome(); }}
        action={{ content: 'Refer a store too', onAction: () => navigate(REFERRALS_ROUTE) }}
      >
        <p>
          Here&rsquo;s what&rsquo;s unlocked on top of your plan: <strong>{welcome.summary}</strong>.
          Bonus credits are used before your monthly plan credits{expires ? ` and expire ${expires}` : ''}.
          {welcome.daysLeft > 0 ? ` This note stays for ${welcome.daysLeft} more day${welcome.daysLeft === 1 ? '' : 's'}.` : ''}
        </p>
      </Banner>
    </div>
  );
}
